// src/api/http.ts
import axios from 'axios'

const rawBaseUrl: unknown = import.meta.env.VITE_API_BASE_URL

if (typeof rawBaseUrl !== 'string' || rawBaseUrl.trim() === '') {
  throw new Error('VITE_API_BASE_URL is niet geconfigureerd')
}

const baseURL = rawBaseUrl.replace(/\/+$/, '')

export const apiClient = axios.create({
  baseURL,
  withCredentials: false,
})

export const authClient = axios.create({
  baseURL,
  withCredentials: true,
})
